/**
 * Vite inlines `import.meta.env.VITE_API_URL` when `vite build` runs. Static hosts
 * (including Cloudflare Pages) do not inject client env at request time — set
 * `VITE_API_URL` in the Pages project’s environment variables for the branch you
 * build (Production vs Preview), then trigger a **new** deployment so the bundle
 * is rebuilt.
 */
const fromEnv = import.meta.env.VITE_API_URL

if (import.meta.env.PROD && !fromEnv) {
  console.error(
    '[admin] VITE_API_URL was not set at build time. Add it under Cloudflare Pages → Settings → Environment variables (for Production or Preview, matching your deployment), then redeploy with a fresh build.',
  )
}

export const API_BASE_URL = fromEnv || 'http://localhost:4000'
